import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { Entity, ENTITY_TYPE } from 'src/features/entity/types';

const RESOURCE = `sp-core/:parkingId/entities/entity/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    type?: ENTITY_TYPE;
    parent?: string;
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Entity>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ENTITIES_RESOURCE, useQueryHook as useListEntities };
